import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration',
    standalone: true
})
export class DurationPipe implements PipeTransform {

  pad(n: number): string {
    return (n < 10) ? (`0${n}`) : `${n}`;
  }

  transform(value: number, hideZeroHours: boolean = false): string {
    if (!value || !isFinite(value)) {
      return hideZeroHours ? '00:00' : '00:00:00';
    }

    const sec_num = Math.round(value / 1000);
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    const seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hideZeroHours && hours === 0) {
      return `${this.pad(minutes)}:${this.pad(seconds)}`;
    }

    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }
}
